<template>
  <div class="fs-12">
    <b-row>
      <h6 class="pl-12 pt-30 fs-20 title-color">
        <b>Drop Down Options</b>
      </h6>
    </b-row>
    <b-row class="fw-bold pl-12 pt-15 fs-13 text-color">
      Field Requirement.
    </b-row>
    <b-row class="p-0">
      <form class="form-inline pl-12">
        <div class="custom-control custom-checkbox mr-sm-2 pl-0">
          <b-form-checkbox @change="dropDownData.required = !dropDownData.required" v-model="dropDownData.required" class="pl-0"> <span class="pl-25 text-align fs-15 text-color">Required</span> </b-form-checkbox><br />
        </div>
      </form>
    </b-row>
    <b-row class="pb-12">
      <b-col cols="12">
        <hr />
      </b-col>
      <b-col cols="12" class="fw-bold">
        Field Name
      </b-col>
      <b-col cols="12" class="pt-10 fs-15">
        You may name this field for the purposes of data mapping. It will not be visible to the Site Team(s) or participants.
      </b-col>
      <b-col cols="12 pt-12">
        <b-form-input type="text" v-model="dropDownData.fieldName" placeholder="Enter field name" class="form-control fs-15 field-h40" size="sm" v-bind:class="{ 'is-danger': dropDownData.fieldNameErrorMsg }" v-on:keyup.native="checkForErrors" autocomplete="off"></b-form-input>
        <span class="error-style ml-5" v-if="dropDownData.fieldNameErrorMsg">{{ dropDownData.fieldNameErrorMsg }}</span>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import findIndex from "lodash/findIndex";
import filter from "lodash/filter";
import find from "lodash/find";

import schemas from "../../../data/form-components-json/schemas.json";

export default {
  name: "drop-down-prop",
  components: {},
  data() {
    return {
      dropDownData: [],
      choicesGiven: [],
      hideAddNotification: true,
      notifications: [],
      notificationSchema: find(schemas, "fieldType", "DropDown").schemas.notificationSchema
    };
  },
  props: ["dropdownSchema"],
  mounted() {
    this.dropDownData = this.dropdownSchema;
    this.notifications = this.dropDownData.notifications || [];
  },
  methods: {
    addNewNotification() {
      const notificationSchema = cloneDeep(this.notificationSchema);
      notificationSchema.notificationConditionFlag = false;
      notificationSchema.notificationContactFlag = false;
      this.notifications.push(notificationSchema);
      this.hideAddNotification = !this.hideAddNotification;
    },

    saveNotification(index) {
      this.notifications[index].notificationContactFlag = false;
      this.notifications[index].notificationConditionFlag = false;
      const selectedContactsList = filter(this.notifications[index].contacts, "status", true);
      let modeOfNotificationErroCount = 0;
      // get notifications where contact is selected but no mode of notification ( sms or email)
      selectedContactsList.forEach(contact => {
        if (!contact.sms && !contact.email) {
          modeOfNotificationErroCount += 1;
        }
      });
      // check for the notification trigger condition ( check for the option whether selected )
      if (!this.notifications[index].triggerCondition.selectedOptionVal) {
        this.notifications[index].notificationConditionFlag = true;
      } else if (filter(this.notifications[index].contacts, "status", true).length <= 0) {
        // check if any contact is selected ot not for notification
        this.notifications[index].notificationContactFlag = true;
      } else if (modeOfNotificationErroCount > 0) {
        // check notifications where contact is selected but no mode of notification ( sms or email)
        const selectedContacts = filter(this.notifications[index].contacts, "status", true);
        selectedContacts.forEach(contact => {
          if (!contact.sms && !contact.email) {
            this.notifications[index].notificationContactFlag = true;
          }
        });
      } else {
        this.notifications[index].mode = !this.notifications[index].mode;
        this.hideAddNotification = !this.hideAddNotification;
        this.choicesGiven[index].disabled = true;
        this.dropDownData.notifications = this.notifications;
        this.dropDownData.notifications[index].name = `${this.dropDownData.notifications[index].name} ${index + 1}`;
      }
    },

    removeNotification(index) {
      this.choicesGiven[index].disabled = false;
      this.notifications.splice(index, 1);
      const tempNotifications = this.notifications;
      this.notifications = [];
      tempNotifications.forEach((notification, ind) => {
        const tempNotification = notification;
        tempNotification.name = `Notification ${ind + 1}`;
        this.notifications.push(tempNotification);
      });
      this.dropDownData.notifications = this.notifications;
    },

    addContact(index) {
      this.notifications[index].contacts.push({
        status: true,
        name: "Sari Patel(PhV)",
        email: false,
        sms: false
      });
    },

    findOptionVal(index, optIndex) {
      // find choice selected from available choice
      // then store that choice value in notification data
      if (!this.dropDownData.options[findIndex(this.dropDownData.options, ["index", optIndex])]) {
        this.notifications[index].triggerCondition.selectedOptionVal = "";
      } else {
        this.notifications[index].triggerCondition.selectedOptionVal = this.dropDownData.options[findIndex(this.dropDownData.options, ["index", optIndex])].label;
      }
    },

    checkForErrors() {
      if (this.dropDownData.fieldName && this.dropDownData.fieldName.trimEnd().length > 0) {
        this.dropDownData.fieldNameErrorMsg = "";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.text-align {
  line-height: 23px !important;
}

.error-style {
  font-size: 12px;
  color: #ff4848;
  padding-bottom: 5px;
}

.is-danger {
  border-color: #ff4848;
}

/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div {
  background-color: #1e8fe1;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
  margin-left: -15px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div {
  background-color: #d5d7dc;
  height: 9px;
  width: 33px;
}
/deep/.vue-switcher-theme--custom.vue-switcher-color--blue.vue-switcher--unchecked div:after {
  background-color: #ffffff;
  border: 1px solid #1e8fe1;
  height: 15px;
  width: 15px;
}
</style>
